import { useMemo, useState } from 'react';
import {
  GestureResponderEvent,
  PanResponderGestureState,
  useWindowDimensions,
} from 'react-native';

const AVATAR_DIAMETER = 100;

export const useAvatarBubble = () => {
  const { height, width } = useWindowDimensions();

  const initial_location = useMemo(
    () => ({
      x: width - (AVATAR_DIAMETER + 20),
      y: height - (AVATAR_DIAMETER + 90),
    }),
    [height, width]
  );

  const [current_location, setCurrentLocation] = useState({
    x: width - AVATAR_DIAMETER / 2 - 20,
    y: height - AVATAR_DIAMETER / 2 - 90,
  });

  const onDragRelease = (
    _: GestureResponderEvent,
    state: PanResponderGestureState
  ) =>
    setCurrentLocation({
      x: state.moveX,
      y: state.moveY,
    });

  return {
    initial_location,
    current_location,
    onDragRelease,
  };
};
